import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';
import { i18n } from '@/plugins/vue-i18n';
import { store } from '@/store/index';
import {
  dispatchGetCompanyWhitelistIp,
  dispatchGetClientIp,
} from '@/store/main/actionsMain';
import { readAssertedCompanyId } from '@/store/main/getters';

import IpAddressTable from '@/views/pages/ipAddressRestriction/IpAddressTable.vue';
import AddIpAddress from '@/views/pages/ipAddressRestriction/AddIpAddress.vue';
import PageDemo from '@/views/pages/ipAddressRestriction/IpAddressRestrictionPageDemo.vue';
import { CompanyWhiteListIpGetResponse } from '@/interfaces/api/general/company';
import { useCompanyFeatureComposable } from '@/composables/useCompanyFeatures';


export default /*#__PURE__*/_defineComponent({
  __name: 'IpAddressRestrictionPage',
  setup(__props) {

const $t = i18n.t.bind(i18n);

const m = defineMessages({
  whitelistIpNotice: 'ホワイトリストIPアドレス登録時の注意事項',
  noticeItem1:
    'ホワイトリストIPアドレスが登録されていない場合、全てのIPアドレスからのアクセスが許可されます。',
  noticeItem2:
    'ホワイトリストIPアドレスが登録されている場合、登録されているいずれかのIPアドレスを経由したアクセスのみが許可されます。',
  noticeItem3:
    '最初にIPアドレスを登録する際は、必ず許可したいIPアドレスを経由してアクセスしてください。登録しようとしているIPアドレスが、現在経由しているいずれかのIPアドレスと一致しない場合は登録できません。',
  noticeItem4:
    '名前変更したい場合は、一度IPアドレスを削除して、再登録時に名前を設定してください。',
  currentClientIpDescription:
    'このアクセスが経由しているすべてのIPアドレスを確認できます',
});

const ipAddressList = ref<CompanyWhiteListIpGetResponse['data']>([]);
const clientIpList = ref<string[]>([]);

const { isFeatureActive, COMPANY_FEATURES } = useCompanyFeatureComposable();

const isIpAddressRestrictionActive = computed(() =>
  isFeatureActive(COMPANY_FEATURES.MANAGE_IP_ADDRESS)
);

const getCompanyWhitelistIp = async (): Promise<void> => {
  const response = await dispatchGetCompanyWhitelistIp(store, {
    companyId: readAssertedCompanyId(store),
  });

  ipAddressList.value = response.data;
};

const getClientIp = async (): Promise<void> => {
  const response = await dispatchGetClientIp(store);
  if (!response) {
    return;
  }
  clientIpList.value = response.data['ip_addresses'] || [];
};

onMounted(async () => {
  if (isIpAddressRestrictionActive.value) {
    const tasks = [getCompanyWhitelistIp()];
    tasks.push(getClientIp());
    await Promise.all(tasks);
  }
});

return { __sfc: true,$t, m, ipAddressList, clientIpList, isFeatureActive, COMPANY_FEATURES, isIpAddressRestrictionActive, getCompanyWhitelistIp, getClientIp, sharedMessages, IpAddressTable, AddIpAddress, PageDemo }
}

})